/* src/app/components/login/login.component.scss */
button:focus {
  outline-color: #380415;
}
.modal-content {
  background-color: #f7f7f7;
  border-radius: 2px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}
.modal-container {
  padding: 30px;
  max-width: 380px;
  width: 100% !important;
  margin: 0 auto;
  border-radius: 2px;
  overflow: hidden;
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
}
.modal-container h1 {
  text-align: center;
  font-size: 1.8rem;
}
.modal-container h2 {
  text-align: center;
  font-size: 1.5em;
}
.modal-container h3.traco {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 0 20px;
}
.modal-container h3.traco span {
  background-color: #f7f7f7;
  padding: 0 10px;
}
.modal-container .form-field {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}
.loginmodal {
  text-align: center;
  font-size: 14px;
  font-family: "Arial", sans-serif;
  font-weight: 700;
  height: 36px;
  padding: 0 8px;
}
.loginmodal-login {
  border: 0px;
  font-weight: 700;
  padding: 6px 12px;
  font-size: 14px;
  width: 193px;
}
.modal-buttons {
  width: 100%;
}
.modal-buttons button {
  width: 100%;
  margin: 10px 0px;
  padding: 6px;
  align-items: center;
}
.registerModal-icon {
  width: 30px;
  height: 30px;
  float: left;
  margin: 3px;
  vertical-align: middle;
}
.email-icon {
  transform: scale(1.3);
  vertical-align: middle;
  line-height: 1.95rem;
  padding-left: 0.2rem;
}
.google-icon {
  background: url("data:image/svg+xml,%3Csvg enable-background='new 0 0 533.5 544.3' version='1.1' viewBox='0 0 533.5 544.3' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:ns='&amp;ns_sfw;' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3E%3Cpath d='m533.5 278.4c0-18.5-1.5-37.1-4.7-55.3h-256.7v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z' style='fill:%234285f4'/%3E%3Cpath d='m272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3h-90.5v70.1c46.2 91.9 140.3 149.9 243.2 149.9z' style='fill:%2334a853'/%3E%3Cpath d='M119.3,324.3c-11.4-33.8-11.4-70.4,0-104.2V150H28.9c-38.6,76.9-38.6,167.5,0,244.4L119.3,324.3z' style='fill:%23fbbc04'/%3E%3Cpath d='m272.1 107.7c38.8-0.6 76.3 14 104.4 40.8l77.7-77.7c-49.2-46.2-114.5-71.6-182.1-70.8-102.9 0-197 58-243.2 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z' style='fill:%23ea4335'/%3E%3C/svg%3E") no-repeat;
}
.facebook-icon {
  background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xml%3Aspace%3D%22preserve%22%20viewBox%3D%220%200%2040%2040%22%3E%3ClinearGradient%20id%3D%22a%22%20x1%3D%22-277.375%22%20x2%3D%22-277.375%22%20y1%3D%22406.6018%22%20y2%3D%22407.5726%22%20gradientTransform%3D%22matrix(40%200%200%20-39.7778%2011115.001%2016212.334)%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%230062e0%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%2319afff%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url(%23a)%22%20d%3D%22M16.7%2039.8C7.2%2038.1%200%2029.9%200%2020%200%209%209%200%2020%200s20%209%2020%2020c0%209.9-7.2%2018.1-16.7%2019.8l-1.1-.9h-4.4l-1.1.9z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22m27.8%2025.6.9-5.6h-5.3v-3.9c0-1.6.6-2.8%203-2.8H29V8.2c-1.4-.2-3-.4-4.4-.4-4.6%200-7.8%202.8-7.8%207.8V20h-5v5.6h5v14.1c1.1.2%202.2.3%203.3.3%201.1%200%202.2-.1%203.3-.3V25.6h4.4z%22%2F%3E%3C%2Fsvg%3E") no-repeat;
}
.registerEmailModal-buttons {
  width: 100%;
}
.registerEmailModal-buttons button {
  width: 50%;
  padding: 6px 12px;
}
.loginmodal-submit:hover {
  border: 0px;
  text-shadow: 0 1px rgba(0, 0, 0, 0.3);
  background-color: #380415;
}
.loginmodal-container a {
  text-decoration: none;
  color: #666;
  font-weight: 400;
  text-align: center;
  display: inline-block;
  opacity: 0.6;
  transition: opacity ease 0.5s;
}
.login-help {
  font-size: 13px;
  padding-bottom: 20px;
  margin-top: 15px;
}
.login-help a {
  cursor: pointer;
}
.login-help a:hover,
.login-help a:focus,
.login-help a:active {
  color: #380415;
}
.login-buttons {
  text-align: center;
}
.login-buttons img {
  cursor: pointer;
  border: 1px solid white;
}
.login-buttons img:hover,
.login-buttons img:focus,
.login-buttons img:active {
  border: 1px solid #380415;
}
.login-buttons img:active,
.login-buttons img:focus {
  box-shadow: 0 0 0 0.2rem #da8505 !important;
}
.ou {
  background-color: #fff;
}
.wrong-login {
  margin-bottom: 2rem;
  background-color: #77082d;
  color: white;
  width: 100%;
  font-weight: 600;
  text-align: center;
}
/*# sourceMappingURL=login.component-Y5QRXYPJ.css.map */
